import Pc360Ad from "../utils/360";
import { isRemIfengPage, getRemPageFont, getWH} from "../core/remPage";
import SendUrls from "If_AdTool/common/sendUrl";
function renderFn(adData, el) {
    let { w, h, data360, isTemplet, click_imp_arr, imp_arr } = adData;
    let remIfengArr = ['imageHeight', 'imageWidth', 'titleFontSize', 'titlePaddingLeft', 'titleFontWeight']
    if (isRemIfengPage()) {
        let fsize = getRemPageFont();
        if(data360.hasOwnProperty('w')) {
            data360.w = getWH(data360.w, fsize);
        }
        if(data360.hasOwnProperty('h')) {
            data360.h = getWH(data360.h, fsize);
        }
        for (let j = 0, len = remIfengArr.length; j < len; j++) {
            for (let i in data360.define) {
                if (i == remIfengArr[j]) {
                    data360.define[i] =  getWH(data360.define[i], fsize)
                }
            }
        }
    }
    Pc360Ad({
        data360,//百度 tuid
        w,//宽
        h, //高
        hasAdTag: true
    }, el);
    if (isTemplet = "on") {
        SendUrls(imp_arr);
        el.addEventListener("click", () => {
            SendUrls(click_imp_arr);
        })
    }
};
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.imgtxt360 = { render: renderFn, version: "1.0.0" };
}